import {
    Component
} from '@angular/core';
import {
    ChangeDetectorRef
} from '@angular/core';
import {
    ApperyioHelperService
} from './scripts/apperyio/apperyio_helper';
import {
    ApperyioMappingHelperService
} from './scripts/apperyio/apperyio_mapping_helper';
import {
    Platform
} from '@ionic/angular';
import {
    ViewChild
} from '@angular/core';
import {
    SplashScreen
} from '@ionic-native/splash-screen/ngx';
import {
    StatusBar
} from '@ionic-native/status-bar/ngx';
import {
    Storage
} from '@ionic/storage';
import {
    Geolocation
} from '@ionic-native/geolocation/ngx';
import {
    ExportedClass as NeurService
} from './scripts/custom/NeurService';
import {
    ExportedClass as GlobalPlaceInfoService
} from './scripts/custom/GlobalPlaceInfoService';
import {
    ExportedClass as PlaceService
} from './scripts/custom/PlaceService';
import {
    ExportedClass as NeurBackendService
} from './scripts/custom/NeurBackendService';
import {
    ExportedClass as UserService
} from './scripts/custom/UserService';
import {
    MAP_PROVIDERS
} from './scripts/custom/NeurConstants';
import {
    MAP_LOCATION_UPDATE
} from './scripts/custom/NeurConstants';
import {
    SERVICE
} from './scripts/custom/NeurConstants';
import {
    BackgroundGeolocationConfig
} from '@ionic-native/background-geolocation/ngx';
import {
    BackgroundGeolocation
} from '@ionic-native/background-geolocation/ngx';
import {
    NativeGeocoder
} from '@ionic-native/native-geocoder/ngx';
import {
    NativeGeocoderOptions
} from '@ionic-native/native-geocoder/ngx';
import {
    CURRENT_PLACE
} from './scripts/custom/PlaceService';
import {
    TranslateService
} from '@ngx-translate/core';
import {
    PLACE_PARAMETERS
} from './scripts/custom/PlaceService';
import * as moment from 'moment';
import {
    $aio_empty_object
} from './scripts/interfaces';
@Component({
    templateUrl: 'app.html',
    selector: 'app-root',
    styleUrls: ['app.css', 'app.scss']
})
export class app {
    public deviceType: string = 'web-browser';
    public geoCoderOptions: NativeGeocoderOptions;
    public $a: ApperyioHelperService;
    public $v: {
        [name: string]: any
    };
    public aioChangeDetector: ChangeDetectorRef;
    public currentItem: any = null;
    @ViewChild('_aio_content') _aio_content;
    public mappingData: any = {};
    public __getMapping(_currentItem, property, defaultValue, isVariable?, isSelected?) {
        return this.$aio_mappingHelper.getMapping(this.mappingData, _currentItem, property, defaultValue, isVariable, isSelected);
    }
    public __isPropertyInMapping(_currentItem, property) {
        return this.$aio_mappingHelper.isPropertyInMapping(this.mappingData, _currentItem, property);
    }
    public __setMapping(data: any = {}, keyName: string, propName?: string): void {
        const changes = data.detail || {};
        if (propName) {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes[propName]);
        } else {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes.value);
        }
        this.$aio_changeDetector.detectChanges();
    }
    public __bindedMethods: any = {};
    constructor(public Apperyio: ApperyioHelperService, private $aio_mappingHelper: ApperyioMappingHelperService, private $aio_changeDetector: ChangeDetectorRef, public splashScreen: SplashScreen, public statusBar: StatusBar, public platform: Platform, public neurService: NeurService, public nativeGeocoder: NativeGeocoder, public backendService: NeurBackendService, public backgroundGeolocation: BackgroundGeolocation, public globalPlaceInfoService: GlobalPlaceInfoService, public storage: Storage, public translateService: TranslateService, public placeService: PlaceService, public userService: UserService) {
        this.$a = this.Apperyio;
        this.$v = this.Apperyio.vars;
        this.aioChangeDetector = this.$aio_changeDetector;
        this.deviceType = window.cordova? 'mobile': 'web-browser';
        // do not remove this code unless you know what you do
        this.platform.ready().then(() => {
            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            if (window.cordova) {
                this.statusBar.styleDefault();
            }
            this.neurService.setScreenOrientation();
            this.neurService.subscribeScreenOrientation();
        });
        this.initialization();
    }
    async initialization(): Promise < any > {
        const locale = this.setup_locale_translations();
        this.setup_month_week_abbreviations(locale);
        this.setup_metrics(locale);
        this.storage.ready().then(() => {
            //    console.log('Storage Engine:'+this.storage.driver);   
        });
        let current_versions = await this.storage.get(SERVICE.CURRENT_VERSION_STORAGE);
        if (!current_versions) {
            current_versions = {
                software: SERVICE.APP_VERSION,
                country_region_list: 0,
                global_place_list: 0
            };
            await this.storage.set(SERVICE.CURRENT_VERSION_STORAGE, current_versions);
        }
        if (current_versions.software < SERVICE.APP_VERSION) {
            current_versions.software = SERVICE.APP_VERSION;
            current_versions.country_region_list = 0;
            current_versions.global_place_list = 0;
        }
        await this.setup_all_countries_info(current_versions, locale);
        this.neurService.setupDialogBoxMessages();
        await this.userService.load_user_infobase();
        this.neurService._initialDataLoaded = true;
        await this.setup_location_services();
        this.neurService.current_place = CURRENT_PLACE;
        this.neurService.current_place.coordinates = this.neurService.current_location;
        await this.placeService.updatePlace(this.neurService.current_place);
        this.placeService.setupMapZoomLayers();
        this.neurService._locationInitialized = true;
        this.neurService._placesInitialized = true;
        await this.setup_all_places_info(current_versions, locale);
        this.neurService._initialized = true;
    }
    setup_metrics(locale): any {
        moment.locale(locale);
        let data = moment.localeData(locale);
        let ltField = data.longDateFormat('LT');
        if (ltField.startsWith("H:")) {
            ltField = ltField.replace("H", "HH");
            moment.updateLocale(locale, {
                longDateFormat: < any > {
                    LT: ltField
                }
            });
        } else if (ltField.startsWith("h:")) {
            ltField = ltField.replace("h", "hh");
            moment.updateLocale(locale, {
                longDateFormat: < any > {
                    LT: ltField
                }
            });
        }
        this.neurService.metrics_setting = {
            temperature: 'celsius'
        }
    }
    setup_month_week_abbreviations(locale): any {
        // Function to format the month as abbreviation
        function getAbbreviatedMonth(month: number): string {
            const date = new Date();
            date.setMonth(month);
            return new Intl.DateTimeFormat(locale, {
                month: 'short'
            }).format(date);
        }
        const monthAbbreviationArray: String[] = [];
        for (let i = 0; i < 12; i++)
            monthAbbreviationArray.push(getAbbreviatedMonth(i).toUpperCase());
        //this.neurService.setMonthAbbreviations(monthAbbreviationArray);
        this.neurService.monthAbbreviations = monthAbbreviationArray;

        function getAbbreviatedWeekdays(weekday: number): string {
            const date = new Date(2023, 0, weekday);
            return new Intl.DateTimeFormat(locale, {
                weekday: 'short'
            }).format(date);
        }
        const weekdaysAbbreviationArray: String[] = [];
        for (let i = 1; i <= 7; i++)
            weekdaysAbbreviationArray.push(getAbbreviatedWeekdays(i).toUpperCase());
        this.neurService.weekdaysAbbreviations = weekdaysAbbreviationArray;
    }
    setup_locale_translations(): any {
        // Set the desired locale
        var locale = navigator.language;
        let translation_code;
        if (locale.startsWith('zh')) {
            if (locale != 'zh-CN') {
                locale = 'zh-TW';
                translation_code = 'zh_TW';
            } else {
                translation_code = 'zh_CN';
            }
        } else {
            translation_code = locale.substring(0, 2);
        }
        this.neurService.setLocale(locale);
        //this.Apperyio.translate.use(translation_code);
        this.translateService.use(translation_code);
        if (locale.startsWith('ar') || this.platform.isRTL) document.documentElement.setAttribute('dir', 'rtl');
        return locale;
    }
    async setup_all_countries_info(current_versions, locale): Promise < any > {
        let latest_countryListVersion = await this.backendService.getVersionNumber('country_region_list');
        const _nonEnglish: boolean = !locale.startsWith('en');
        if (latest_countryListVersion > current_versions.country_region_list) {
            let country_region_list = await this.backendService.getAllCountriesName(locale);
            if (country_region_list) {
                await this.globalPlaceInfoService.setAllCountriesInfo(country_region_list, _nonEnglish);
                current_versions.country_region_list = latest_countryListVersion;
                await this.storage.set(SERVICE.CURRENT_VERSION_STORAGE, current_versions);
            } else {
                await this.globalPlaceInfoService.retreiveAllCountriesInfo();
            }
        } else if (current_versions.country_region_list > 0) {
            await this.globalPlaceInfoService.retreiveAllCountriesInfo();
        }
    }
    async setup_location_services(): Promise < any > {
        this.neurService.setMapProvider(MAP_PROVIDERS.LEAFLET);
        await this.neurService.getCurrentLocation();
        if (this.neurService.ip_country_code == 'CN') {
            this.neurService.setLeafletBaseMap(MAP_PROVIDERS.LEAFLET_BASEMAP.BAIDU);
        } else {
            this.neurService.setLeafletBaseMap(MAP_PROVIDERS.LEAFLET_BASEMAP.GOOGLE);
        }
        if (window.cordova) {
            try {
                //    const config: BackgroundGeolocationConfig = {
                const config = {
                    desiredAccuracy: this.neurService.location_desired_accuracy,
                    stationaryRadius: this.neurService.location_stationary_radius,
                    distanceFilter: MAP_LOCATION_UPDATE.THRESHOLD,
                    stopOnTerminate: true,
                    interval: MAP_LOCATION_UPDATE.FREQUENCY
                };
                this.backgroundGeolocation.configure(config)
                    .then(() => {
                        this.backgroundGeolocation.getCurrentLocation().then((location) => {
                            this.neurService.current_location = location;
                            console.log(location.latitude, location.longitude);
                        });
                        this.backgroundGeolocation.start();
                    });
                this.splashScreen.hide();
            } catch (e) {
                console.log(e)
            }
        } else {
            navigator.geolocation.watchPosition((position) => {
                this.neurService.current_location = position.coords;
                this.neurService._locationBasedOnGeo = true;
            }, (error) => {
                this.neurService._locationBasedOnGeo = false;
            }, {
                enableHighAccuracy: this.neurService.location_high_accuracy,
                timeout: MAP_LOCATION_UPDATE.TIMEOUT,
                maximumAge: MAP_LOCATION_UPDATE.FREQUENCY
            });
        }
    }
    async setup_all_places_info(current_versions, locale): Promise < any > {
        let latest_globalPlaceListVersion = await this.backendService.getVersionNumber('global_place_list');
        const _nonEnglish: boolean = !locale.startsWith('en');
        if (latest_globalPlaceListVersion > current_versions.global_place_list) {
            let global_place_list = await this.backendService.getAllPlacesName(locale);
            console.log("number of places: " + global_place_list.length)
            if (global_place_list) {
                this.globalPlaceInfoService.setAllPlacesInfo(global_place_list, _nonEnglish);
                current_versions.global_place_list = latest_globalPlaceListVersion;
                await this.storage.set(SERVICE.CURRENT_VERSION_STORAGE, current_versions);
            } else {
                this.globalPlaceInfoService.retreiveAllPlacesInfo();
            }
        } else if (current_versions.global_place_list > 0) {
            this.globalPlaceInfoService.retreiveAllPlacesInfo();
        }
    }
    ngOnInit() {
        this.$a.preload.components(["ion-input", "ion-modal", "ion-textarea", "ion-toast", "ion-datetime", "ion-select", "ion-popover", "ion-item"]);
        this.Apperyio.setThinScrollIfNeeded();
    }
    ionViewWillEnter() {
        window.currentScreen = this;
    }
}